module.exports = __webpack_public_path__ + "img/paypal.8a185582.svg";